module.exports = __webpack_public_path__ + "redeem-benefit.svg?9fb2775293a7d690af7494719c8ea0db";